import ahoy from "ahoy.js";
ahoy.configure({ cookies: false });

export default class UserAddToCart {
  constructor(options) {
    this.addToCartListener();
  }

  addToCartListener() {
    document.querySelectorAll(".product-element a").forEach((link) => {
      link.addEventListener("click", this.addToCart.bind(this));
    });
  }

  addToCart(event) {
    let productElement = event.target.closest(".product-element");
    let userPageId = document.querySelector("[data-user-page-id]")?.dataset
      ?.userPageId;

    let data = {
      pid: parseInt(productElement.dataset.productId, 10),
      user_page_id: parseInt(userPageId, 10),
    };

    ahoy.track("playground:addToCart", data);
  }
}
